import { pageRoutes } from './pageRoutes.constant';
import scroll_down from '../assets/gifs/scroll-down.gif';
import SDE from '../assets/gifs/sde.gif';
import Operations from '../assets/gifs/operations.gif';
import ui from '../assets/gifs/ui-ux.gif';
import cloud from '../assets/gifs/cloud.gif';
import qa from '../assets/gifs/qa.gif';
import aimlGif from "../assets/gifs/aiml.gif";
import iotGif from "../assets/gifs/IoT.gif";



const S3_IMAGES_BASE_URL = (
  process.env.REACT_APP_S3_IMAGES_BASE_URL ||
  'https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/assets'
).replace(/\/$/, '');

export const knox_hero1 = `${S3_IMAGES_BASE_URL}/marketplace/knox-hero1.svg`;
export const knox_hero2 = `${S3_IMAGES_BASE_URL}/marketplace/knox-hero2.svg`;
export const knox_logo = `${S3_IMAGES_BASE_URL}/marketplace/KnoxHR-logo.svg`;
export const knox_hero1_mob = `${S3_IMAGES_BASE_URL}/marketplace/knoxhr-hero1-mob.svg`;
export const knox_hero2_mob = `${S3_IMAGES_BASE_URL}/marketplace/knoxhr-hero2-mob.svg`;
export const satm_hero1 = `${S3_IMAGES_BASE_URL}/marketplace/satm-hero1.svg`;
export const satm_hero2 = `${S3_IMAGES_BASE_URL}/marketplace/satm-hero2.svg`;
export const satm_logo = `${S3_IMAGES_BASE_URL}/marketplace/SATM-logo.svg`;
export const satm_hero1_mob = `${S3_IMAGES_BASE_URL}/marketplace/satm-hero1-mob.svg`;
export const satm_hero2_mob = `${S3_IMAGES_BASE_URL}/marketplace/satm-hero2-mob.svg`;
export const stressops_hero1 = `${S3_IMAGES_BASE_URL}/marketplace/StressOps-hero2.svg`;
export const stressops_hero2 = `${S3_IMAGES_BASE_URL}/marketplace/StressOps-hero1.svg`;
export const stressops_logo = `${S3_IMAGES_BASE_URL}/marketplace/StressOps-logo.svg`;
export const stressops_hero1_mob = `${S3_IMAGES_BASE_URL}/marketplace/stressops-hero1-mob.svg`;
export const stressops_hero2_mob = `${S3_IMAGES_BASE_URL}/marketplace/stressops-hero2-mob.svg`;
export const qufree_hero1 = `${S3_IMAGES_BASE_URL}/marketplace/qufree-hero1.svg`;
export const qufree_hero2 = `${S3_IMAGES_BASE_URL}/marketplace/qufree-hero2.svg`;
export const qufree_logo = `${S3_IMAGES_BASE_URL}/marketplace/QuFree-logo.svg`;
export const cxo_hero = `${S3_IMAGES_BASE_URL}/marketplace/cxo-hero.svg`;
export const cxo_hero_mob = `${S3_IMAGES_BASE_URL}/marketplace/cxo-hero-mobile.svg`;
export const cxo_logo = `${S3_IMAGES_BASE_URL}/marketplace/cxo-logo.svg`;
export const cxo_marketing = `${S3_IMAGES_BASE_URL}/marketplace/cxo-marketing.svg`;
export const cxo_engineering = `${S3_IMAGES_BASE_URL}/marketplace/cxo-engineering.svg`;
export const cxo_cloud = `${S3_IMAGES_BASE_URL}/marketplace/cxo-cloud.svg`;
export const cxo_finance = `${S3_IMAGES_BASE_URL}/marketplace/cxo-finance.svg`;
export const cxo_hubspot = `${S3_IMAGES_BASE_URL}/marketplace/cxo-hubspot.svg`;
export const cxo_postman = `${S3_IMAGES_BASE_URL}/marketplace/cxo-postman.svg`;
export const cxo_github = `${S3_IMAGES_BASE_URL}/marketplace/cxo-github.svg`;
export const cxo_gcloud = `${S3_IMAGES_BASE_URL}/marketplace/cxo-gcloud.svg`;
export const cxo_azure = `${S3_IMAGES_BASE_URL}/marketplace/cxo-azure.svg`;
export const cxo_zoho = `${S3_IMAGES_BASE_URL}/marketplace/cxo-zoho.svg`;
export const duwise_hero1 = `${S3_IMAGES_BASE_URL}/marketplace/duwise-hero1.svg`;
export const duwise_hero2 = `${S3_IMAGES_BASE_URL}/marketplace/duwise-hero2.svg`;
export const duwise_logo = `${S3_IMAGES_BASE_URL}/marketplace/duwise-logo.svg`;
export const orcaflo_hero1 = `${S3_IMAGES_BASE_URL}/marketplace/orcaflo-hero1.svg`;
export const orcaflo_hero2 = `${S3_IMAGES_BASE_URL}/marketplace/orcaflo-hero2.svg`;
export const orcaflo_logo = `${S3_IMAGES_BASE_URL}/marketplace/orcaflo-logo.svg`;
export const orcaflo_hero1_mob = `${S3_IMAGES_BASE_URL}/marketplace/orkaflo-hero1-mob.svg`;
export const orcaflo_hero2_mob = `${S3_IMAGES_BASE_URL}/marketplace/orkaflo-hero12-mob.svg`;

// Marketplace Card SVGs
export const marketplace_knoxHR = `${S3_IMAGES_BASE_URL}/marketplace/marketplace-knoxHR.svg`;
export const marketplace_duwise = `${S3_IMAGES_BASE_URL}/marketplace/marketplace-duwise.svg`;
export const marketplace_qufree = `${S3_IMAGES_BASE_URL}/marketplace/marketplace-qufree.svg`;
export const marketplace_cxotulz = `${S3_IMAGES_BASE_URL}/marketplace/marketplace-cxotulz.svg`;
export const marketplace_satm = `${S3_IMAGES_BASE_URL}/marketplace/marketplace-SATM.svg`;
export const marketplace_orkaflo = `${S3_IMAGES_BASE_URL}/marketplace/marketplace-orkaflo.svg`;
export const marketplace_stressops = `${S3_IMAGES_BASE_URL}/marketplace/marketplace-stressOps.svg`;
export const marketplace_banner = `${S3_IMAGES_BASE_URL}/marketplace/marketplace-banner.svg`;

const os_welcomekit = `${S3_IMAGES_BASE_URL}/os-welcomekit.svg`;
const os_welcomekit_2 = `${S3_IMAGES_BASE_URL}/welcome-kit-2.png`;
const os_team_img = `${S3_IMAGES_BASE_URL}/os-team-img.svg`;
const team_img = `${S3_IMAGES_BASE_URL}/team-img.png`;
const os_team_img2 = `${S3_IMAGES_BASE_URL}/os-team-img1.jpg`;
const mission_img = `${S3_IMAGES_BASE_URL}/about-us-mission.jpg`;
const robo_img = `${S3_IMAGES_BASE_URL}/about-us-vision.jpg`;
const core_value_diagram = `${S3_IMAGES_BASE_URL}/core-value.svg`;
const integrity_value = `${S3_IMAGES_BASE_URL}/integrity.svg`;
const diligence_value = `${S3_IMAGES_BASE_URL}/deligence.svg`;
const ownership_value = `${S3_IMAGES_BASE_URL}/ownership-value.svg`;
const discipline_value = `${S3_IMAGES_BASE_URL}/discipline.svg`;
const commitment_value = `${S3_IMAGES_BASE_URL}/commitment.svg`;
const open_communication_value = `${S3_IMAGES_BASE_URL}/open-communication.svg`;
const card_group = `${S3_IMAGES_BASE_URL}/card-group.svg`;
const globe = `${S3_IMAGES_BASE_URL}/card-globe.svg`;
const pool_group = `${S3_IMAGES_BASE_URL}/card-talent.svg`;
const tech_competence = `${S3_IMAGES_BASE_URL}/card-tech-ompetence.svg`;
const cost_optimization = `${S3_IMAGES_BASE_URL}/card-cost-optmization.svg`;
const awards_img = `${S3_IMAGES_BASE_URL}/award-img.jpg`;
const awards_img1 = `${S3_IMAGES_BASE_URL}/award-img1.svg`;
const circle_dot = `${S3_IMAGES_BASE_URL}/circles.svg`;
const red_rect = `${S3_IMAGES_BASE_URL}/red-rect.svg`;
const blue_rect = `${S3_IMAGES_BASE_URL}/blue-rect.svg`;
const leadeship_bg = `${S3_IMAGES_BASE_URL}/leadership-bg.png`;
const linkdin_icon = `${S3_IMAGES_BASE_URL}/linkedIn.svg`;
const mail_icon = `${S3_IMAGES_BASE_URL}/mail.svg`;
const os_ashav_img = `${S3_IMAGES_BASE_URL}/os-ashav-img.svg`;
const square_red = `${S3_IMAGES_BASE_URL}/square-red.svg`;
const rect_blue = `${S3_IMAGES_BASE_URL}/rect-blue.svg`;
const card = `${S3_IMAGES_BASE_URL}/card-bg.png`;
const landing1 = `${S3_IMAGES_BASE_URL}/landing1.jpg`;
const landing2 = `${S3_IMAGES_BASE_URL}/landing2.jpg`;
const landing3 = `${S3_IMAGES_BASE_URL}/landing3.jpg`;
const technology_carouel = `${S3_IMAGES_BASE_URL}/technology-carousel.jpg`;
const right_arrow = `${S3_IMAGES_BASE_URL}/white-right-arrow.svg`;
const landing1_mob = `${S3_IMAGES_BASE_URL}/landing1-mob.jpg`;
const landing2_mob = `${S3_IMAGES_BASE_URL}/landing2-mob.jpg`;
const landing3_mob = `${S3_IMAGES_BASE_URL}/landing3-mob.jpg`;
const card_img = `${S3_IMAGES_BASE_URL}/card-img.svg`;
const blueBox = `${S3_IMAGES_BASE_URL}/box.svg`;
const Circles = `${S3_IMAGES_BASE_URL}/circles.svg`;
const netImg = `${S3_IMAGES_BASE_URL}/net-mng-syst.jpg`;
const prev = `${S3_IMAGES_BASE_URL}/previous.png`;
const next = `${S3_IMAGES_BASE_URL}/next.png`;
const blueBg = `${S3_IMAGES_BASE_URL}/blue-bg.svg`;
const consulting = `${S3_IMAGES_BASE_URL}/consultancy.svg`;
const hospitality = `${S3_IMAGES_BASE_URL}/hospitality.svg`;
const group = `${S3_IMAGES_BASE_URL}/group-17917.svg`;
const technology = `${S3_IMAGES_BASE_URL}/technology.svg`;
const transportaion = `${S3_IMAGES_BASE_URL}/transportation.svg`;
const healthcare = `${S3_IMAGES_BASE_URL}/healthcare.svg`;
const realEstate = `${S3_IMAGES_BASE_URL}/tech-enabled-spaces.svg`;
const engage = `${S3_IMAGES_BASE_URL}/employment-community-engagement.svg`;
const organization = `${S3_IMAGES_BASE_URL}/non-governmental-organization.svg`;
const Food = `${S3_IMAGES_BASE_URL}/food-beverage.svg`;
const darkBlueBox = `${S3_IMAGES_BASE_URL}/blue-box.svg`;
const redBox = `${S3_IMAGES_BASE_URL}/red-box.svg`;
const circlesVert = `${S3_IMAGES_BASE_URL}/circles-vert.svg`;
const redVertLine = `${S3_IMAGES_BASE_URL}/red-vert-line.svg`;
const SeBg = `${S3_IMAGES_BASE_URL}/se-bg.png`;
const SeImg = `${S3_IMAGES_BASE_URL}/se-img.png`;
const mobAppDev = `${S3_IMAGES_BASE_URL}/mobile-app-dev.svg`;
const webAppDev = `${S3_IMAGES_BASE_URL}/web-app-dev.svg`;
const productEngg = `${S3_IMAGES_BASE_URL}/product-engineering-icon.svg`;
const softwareEngg = `${S3_IMAGES_BASE_URL}/software-engineering.svg`;
const POC = `${S3_IMAGES_BASE_URL}/proof-of-concepts.svg`;
const Java = `${S3_IMAGES_BASE_URL}/java.svg`;
const Python = `${S3_IMAGES_BASE_URL}/python.svg`;
const Angular = `${S3_IMAGES_BASE_URL}/angular-js.svg`;
const Node = `${S3_IMAGES_BASE_URL}/node-js.svg`;
const ReactNative = `${S3_IMAGES_BASE_URL}/react-native.svg`;
const HTML5 = `${S3_IMAGES_BASE_URL}/html-5.svg`;
const CSS3 = `${S3_IMAGES_BASE_URL}/css3.svg`;
const Vue = `${S3_IMAGES_BASE_URL}/vue-js.svg`;
const Quotes = `${S3_IMAGES_BASE_URL}/quote.svg`;
const facebook = `${S3_IMAGES_BASE_URL}/footer-facebook.svg`;
const Instagram = `${S3_IMAGES_BASE_URL}/footer-instagram.svg`;
const Linkdein = `${S3_IMAGES_BASE_URL}/footer-linkedIn.svg`;
const mail = `${S3_IMAGES_BASE_URL}/social-media-mail.svg`;
const wmpLogo = `${S3_IMAGES_BASE_URL}/logo.png`;
const BULLET = `${S3_IMAGES_BASE_URL}/bulllet.jpg`;
const services_footer_img = `${S3_IMAGES_BASE_URL}/services-footer-bg.jpg`;
const team_bg = `${S3_IMAGES_BASE_URL}/team-bg.jpg`;
const kub_img_mv_1 = `${S3_IMAGES_BASE_URL}/kub-mv-img-1.png`;
const kub_img_mv_2 = `${S3_IMAGES_BASE_URL}/kub-mv-img-2.png`;
const kub_img_mv_3 = `${S3_IMAGES_BASE_URL}/kub-mv-img-3.png`;
const kub_img_mv_4 = `${S3_IMAGES_BASE_URL}/kub-mv-img-4.png`;
const blog_card_img_1 = `${S3_IMAGES_BASE_URL}/blog-card-img-1.svg`;
const blog_card_img_2 = `${S3_IMAGES_BASE_URL}/blog-card-img-2.jpg`;
const blog_card_img_3 = `${S3_IMAGES_BASE_URL}/blog-card-img-3.svg`;
const blog_card_img_5 = `${S3_IMAGES_BASE_URL}/blog-card-img-5.svg`;
const blog_card_img_6 = `${S3_IMAGES_BASE_URL}/blog-card-img-6.jpg`;
const jayant_blog_img = `${S3_IMAGES_BASE_URL}/jayant-blog-img.svg`;
const vikas_blog_img = `${S3_IMAGES_BASE_URL}/vikas-blog-img.svg`;
const samyakt_blog_img = `${S3_IMAGES_BASE_URL}/samyakt-blog-img.svg`;
const mohit_blog_img = `${S3_IMAGES_BASE_URL}/mohit-blog-img.svg`;
const unique_blog_img = `${S3_IMAGES_BASE_URL}/unique-blog-img.svg`;
const harpreet_blog_img = `${S3_IMAGES_BASE_URL}/harpareet-blog-img.svg`;
const kawaldeep_blog_img = `${S3_IMAGES_BASE_URL}/kawaldeep-blog-img.jpg`;
const kekashri_blog_img = `${S3_IMAGES_BASE_URL}/kekashri-blog-img.svg`;
const mukul_blog_img = `${S3_IMAGES_BASE_URL}/mukul-blog-img.jpg`;
const culture_people_img = `${S3_IMAGES_BASE_URL}/culture-people-img.png`;
const culture_people_img_2 = `${S3_IMAGES_BASE_URL}/culture-people-img-2.png`;
const culture_innovation_img = `${S3_IMAGES_BASE_URL}/culture-innovation.png`;
const culture_building_img = `${S3_IMAGES_BASE_URL}/culture-building-img.svg`;
const culture_family_img = `${S3_IMAGES_BASE_URL}/culture-family-img.jpg`;
const culture_people_mob = `${S3_IMAGES_BASE_URL}/culture-people-mob.png`;
const culture_innovation_mob = `${S3_IMAGES_BASE_URL}/culture-innovation-mob.png`;
const culture_building_mob = `${S3_IMAGES_BASE_URL}/culture-building-mob.svg`;
const culture_family_mob = `${S3_IMAGES_BASE_URL}/culture-family-mob.png`;
const network_management_bg = `${S3_IMAGES_BASE_URL}/network-management-background.jpg`;
const technology_bg = `${S3_IMAGES_BASE_URL}/technology-background.jpg`;
const network_mgt_web = `${S3_IMAGES_BASE_URL}/web-network-management.png`;
const technology_web = `${S3_IMAGES_BASE_URL}/web-technology.png`;
const network_mgt_mob = `${S3_IMAGES_BASE_URL}/mob-network-mgmt.png`;
const technology_mob = `${S3_IMAGES_BASE_URL}/mob-technology.png`;
const devops_bg = `${S3_IMAGES_BASE_URL}/devops-bg.jpg`;
const devops_img = `${S3_IMAGES_BASE_URL}/devops-img.jpg`;
const cloud_infra = `${S3_IMAGES_BASE_URL}/cloud-infra.svg`;
const cloud_migration = `${S3_IMAGES_BASE_URL}/cloud-migration.svg`;
const devops_auto = `${S3_IMAGES_BASE_URL}/devOps-auto.svg`;
const devops_operations = `${S3_IMAGES_BASE_URL}/devops-operations.svg`;
const security = `${S3_IMAGES_BASE_URL}/security.svg`;
const devops_badge1 = `${S3_IMAGES_BASE_URL}/devops-badge1.svg`;
const devops_badge2 = `${S3_IMAGES_BASE_URL}/devops-badge2.svg`;
const devops_badge3 = `${S3_IMAGES_BASE_URL}/devops-badge3.svg`;
const devops_badge4 = `${S3_IMAGES_BASE_URL}/devops-badge4.svg`;
const devops_badge5 = `${S3_IMAGES_BASE_URL}/devops-badge5.png`;
const google_cloud = `${S3_IMAGES_BASE_URL}/google-cloud.svg`;
const aws = `${S3_IMAGES_BASE_URL}/aws.svg`;
const azure = `${S3_IMAGES_BASE_URL}/azure.svg`;
const contact_img = `${S3_IMAGES_BASE_URL}/contact-img.png`;
const location = `${S3_IMAGES_BASE_URL}/location.svg`;
const phone_icon = `${S3_IMAGES_BASE_URL}/call.svg`;
const user_icon = `${S3_IMAGES_BASE_URL}/user.svg`;
const mail_contact_icon = `${S3_IMAGES_BASE_URL}/mail-icon.svg`;
const phone_contact_icon = `${S3_IMAGES_BASE_URL}/phone-icon.svg`;
const modal_cross = `${S3_IMAGES_BASE_URL}/cross.svg`;
const contact_mob_img = `${S3_IMAGES_BASE_URL}/contact-mob-img.png`;
const about_ashav_mob = `${S3_IMAGES_BASE_URL}/about-mob-ashav.svg`;
const tech_writing = `${S3_IMAGES_BASE_URL}/tech-writing.svg`;
const product_management = `${S3_IMAGES_BASE_URL}/product-management.svg`;
const project_management = `${S3_IMAGES_BASE_URL}/project-management.svg`;
const monitoring = `${S3_IMAGES_BASE_URL}/monitoring.svg`;
const PMI = `${S3_IMAGES_BASE_URL}/pmi.svg`;
const qa_img = `${S3_IMAGES_BASE_URL}/qa-img.jpg`;
const testing_and_auto = `${S3_IMAGES_BASE_URL}/testing-and-auto.svg`;
const API_driven_testing = `${S3_IMAGES_BASE_URL}/api-driven-testing.svg`;
const performance_testing = `${S3_IMAGES_BASE_URL}/peformance-testing.svg`;
const penetration_testing = `${S3_IMAGES_BASE_URL}/penetration-testing.svg`;
const sumo_qa = `${S3_IMAGES_BASE_URL}/sumo-qa.svg`;
const istqb_qa = `${S3_IMAGES_BASE_URL}/istqb-qa.svg`;
const designing_img = `${S3_IMAGES_BASE_URL}/designing-img.jpg`;
const web_designing = `${S3_IMAGES_BASE_URL}/web-designing.svg`;
const app_designing = `${S3_IMAGES_BASE_URL}/app-designing.svg`;
const info_architecture_design = `${S3_IMAGES_BASE_URL}/info-architecutre-design.svg`;
const operations_img = `${S3_IMAGES_BASE_URL}/operations-img.png`;
const core_robo_img = `${S3_IMAGES_BASE_URL}/vision-mob-img.jpg`;
const core_firework_img = `${S3_IMAGES_BASE_URL}/firework.png`;
const no_compromise = `${S3_IMAGES_BASE_URL}/no-compromise.svg`;
const celebration_1 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-1.jpg`;
const celebration_2 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-2.jpg`;
const celebration_3 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-3.jpg`;
const celebration_4 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-4.jpg`;
const celebration_5 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-5.jpg`;
const celebration_6 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-6.jpg`;
const celebration_7 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-7.jpg`;
const celebration_8 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-8.jpg`;
const celebration_9 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-9.jpg`;
const celebration_10 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-10.jpg`;
const celebration_11 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/diwali.jpg`;
const celebration_12 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/seniors-grp.jpg`;
const celebration_13 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-13.jpg`;
const celebration_14 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-14.jpg`;
const celebration_15 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-15.jpg`;
const celebration_16 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-16.jpg`;
const celebration_17 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-17.jpg`;
const celebration_18 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-18.jpg`;
const celebration_19 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-19.jpg`;
const celebration_20 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-20.jpeg`;
const celebration_21 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-21.jpg`;
const celebration_22 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-22.jpg`;
const celebration_23 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-23.jpg`;
const celebration_25 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-25.jpg`;
const celebration_26 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-26.jpg`;
const celebration_27 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-27.jpeg`;
const celebration_28 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-28.jpg`;
const celebration_29 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-29.jpeg`;
const celebration_30 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-30.jpg`;
const celebration_31 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-31.jpeg`;
const celebration_32 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-32.JPG`;
const celebration_33 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-33.jpg`;
const celebration_34 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-34.jpg`;
const celebration_35 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-35.jpg`;
const celebration_36 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-36.jpeg`;
const celebration_37 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-37.jpeg`;
const celebration_38 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-38.jpeg`;
const celebration_39 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-39.jpeg`;
const celebration_40 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-40.jpg`;
const celebration_41 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-41.JPG`;
const celebration_42 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-42.png`;
const celebration_43 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-43.jpg`;
const celebration_44 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/celebration-44.png`;


const eric = `${S3_IMAGES_BASE_URL}/eric%20.png`;
const rex = `${S3_IMAGES_BASE_URL}/rex%20.png`;
const kapil = `${S3_IMAGES_BASE_URL}/kapilUserIcon.png`;
const serge = `${S3_IMAGES_BASE_URL}/serge-lachapelle.png`;
const male = `${S3_IMAGES_BASE_URL}/male.jpg`;
const female_dummy = `${S3_IMAGES_BASE_URL}/female.jpg`;
const leadership_ashav = `${S3_IMAGES_BASE_URL}/leadership-ashav.jpg`;
const leadership_nishant = `${S3_IMAGES_BASE_URL}/leadership-nishant.jpg`;
const leadership_alok = `${S3_IMAGES_BASE_URL}/leadership-alok.jpg`;
const Rhythm_1 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/rhythm-1.jpg`;
const Rhythm_2 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/rhythm-2.jpg`;
const Rhythm_3 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/rhythm-3.jpg`;
const Rhythm_4 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/rhytm-4.jpeg`;
const Rhythm_5 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/rhythm-5.jpg`;
const Rhythm_6 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/rhythm-6.jpg`;
const Rhythm_7 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/rhythm-7.jpg`;
const Rhythm_8 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/rhythm-8.jpg`;
const Rhythm_9 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/rhythm-9.jpg`;
const Rhythm_10 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/rhythm-10.jpg`;
const Rhythm_11 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/rhythm-11.jpg`;
const Rhythm_12 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/rhythm-12.jpg`;
const Rhythm_13 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/rhythm-13.jpg`;
const Rhythm_14 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/rhythm-14.jpg`;
const Rhythm_15 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/rhythm-15.jpg`;
const Rhythm_16 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/rhythm-16.jpg`;
const Rhythm_17 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/rhythm-17.jpeg`;
const Rhythm_18 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/rhythm-18.jpg`;
const Rhythm_19 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/rhythm-19.JPG`;
const Rhythm_20 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/rhythm-20.jpg`;
const Rhythm_21 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/rhythm-21.jpeg`;
const Rhythm_22 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/rhythm-22.jpeg`;
const Rhythm_23 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/rhythm-23.jpg`;
const Rhythm_24 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/rhythm-24.jpg`;
const Rhythm_25 = `${S3_IMAGES_BASE_URL}/Life_at_wmp/rhythm-25.jpg`;
const ankita_blog_img = `${S3_IMAGES_BASE_URL}/ankita-blog.jpg`;
const anubhav_blog_img_1 = `${S3_IMAGES_BASE_URL}/ux-1st.jpg`;
const anubhav_blog_img_2 = `${S3_IMAGES_BASE_URL}/ux-2nd.jpg`;
const Dashboard_cxo = `${S3_IMAGES_BASE_URL}/dashbords-cxotulz.png`;
const CXOTulz = `${S3_IMAGES_BASE_URL}/cxotulz.svg`;
const solution_bullet = `${S3_IMAGES_BASE_URL}/solution-bullet.svg`;
const cost_analysis = `${S3_IMAGES_BASE_URL}/cost-analysis.png`;
const cloud_switch = `${S3_IMAGES_BASE_URL}/cloud-switch.png`;
const login_vector = `${S3_IMAGES_BASE_URL}/login-vector.png`;
const vector = `${S3_IMAGES_BASE_URL}/vector.png`;
const cxo_report = `${S3_IMAGES_BASE_URL}/cxo-reports.png`;
const trusted_partners = `${S3_IMAGES_BASE_URL}/trusted-partnership.svg`;
const requirement_scrutiny = `${S3_IMAGES_BASE_URL}/requirement-scrutiny.svg`;
const flexible_Payment = `${S3_IMAGES_BASE_URL}/flexible-payment-execution.svg`;
const dedicated_resource = `${S3_IMAGES_BASE_URL}/dedicated-resource-allocation.svg`;
const centralized_support = `${S3_IMAGES_BASE_URL}/centralized-support.svg`;
const ownership = `${S3_IMAGES_BASE_URL}/ownership.svg`;
const mob_dashboard = `${S3_IMAGES_BASE_URL}/mob-dashboard.svg`;
const ankita_blog_gpt = `${S3_IMAGES_BASE_URL}/ankita-gpt-blog.png`;
const cxotulz_logo = `${S3_IMAGES_BASE_URL}/cxotulz-logo.svg`;
const qufree = `${S3_IMAGES_BASE_URL}/qufree.svg`;
const trakwa = `${S3_IMAGES_BASE_URL}/trakwa.svg`;
const trakwa_app = `${S3_IMAGES_BASE_URL}/trakwa-app.svg`;
const trakwa_simplified = `${S3_IMAGES_BASE_URL}/trakwa-simplified.svg`;
const trakwa_thumbnail = `${S3_IMAGES_BASE_URL}/trakwa_thumbnail.jpg`;
const trakwa1 = `${S3_IMAGES_BASE_URL}/trakwa1.svg`;
const trakwa2 = `${S3_IMAGES_BASE_URL}/trakwa2.svg`;
const trakwa3 = `${S3_IMAGES_BASE_URL}/trakwa3.svg`;
const qufree_thumbnail = `${S3_IMAGES_BASE_URL}/qufree_thumbnail.jpg`;
const qufree_screen = `${S3_IMAGES_BASE_URL}/qufree-screen.svg`;
const qu1 = `${S3_IMAGES_BASE_URL}/qu1.svg`;
const qu2 = `${S3_IMAGES_BASE_URL}/qu2.svg`;
const qu3 = `${S3_IMAGES_BASE_URL}/qu3.svg`;
const qu4 = `${S3_IMAGES_BASE_URL}/qu4.svg`;
const qu_register = `${S3_IMAGES_BASE_URL}/register.svg`;
const qu_signup = `${S3_IMAGES_BASE_URL}/signup.svg`;
const qu_phone = `${S3_IMAGES_BASE_URL}/phone.svg`;
const tagline = `${S3_IMAGES_BASE_URL}/tagline.svg`;
const account_created = `${S3_IMAGES_BASE_URL}/acc-created.png`;
const cstm_dashboard = `${S3_IMAGES_BASE_URL}/custm-dasb.png`;
const profile_qufree = `${S3_IMAGES_BASE_URL}/profile-setup.svg`;
const cxo_thumbnail = `${S3_IMAGES_BASE_URL}/cxo-thumbnail.jpg`;
const explore_1 = `${S3_IMAGES_BASE_URL}/explore1.svg`;
const explore_2 = `${S3_IMAGES_BASE_URL}/explore2.svg`;
const explore_3 = `${S3_IMAGES_BASE_URL}/explore3.svg`;
const mob_cxo = `${S3_IMAGES_BASE_URL}/mob_cxo.jpg`;
const mob_trakwa = `${S3_IMAGES_BASE_URL}/mob_trakwa.jpg`;
const mob_qufree = `${S3_IMAGES_BASE_URL}/mob_qufree.png`;
const firebase = `${S3_IMAGES_BASE_URL}/firebase.png`;
const docker = `${S3_IMAGES_BASE_URL}/docker.svg`;
const psql = `${S3_IMAGES_BASE_URL}/psql.png`;
const github = `${S3_IMAGES_BASE_URL}/github_actions.png`;
const sendgrid = `${S3_IMAGES_BASE_URL}/sendgrid.png`;
const mob_hospitality = `${S3_IMAGES_BASE_URL}/mob_hospitality.png`;
const hospitality_story = `${S3_IMAGES_BASE_URL}/hospitality1.png`;
const hospitality_thumbnail = `${S3_IMAGES_BASE_URL}/hospitality_thumbnail.jpg`;
const hospitality_caraousel = `${S3_IMAGES_BASE_URL}/hospitality_caraousel.jpg`;
const mob_healthcare = `${S3_IMAGES_BASE_URL}/mob_healtcare.png`;
const healthcare1 = `${S3_IMAGES_BASE_URL}/healthcare1.png`;
const healthcare_thumbnail = `${S3_IMAGES_BASE_URL}/healthcare_thumbnail.jpg`;
const healthcare_carousel = `${S3_IMAGES_BASE_URL}/healthcare_carousel.jpg`;
const transportation_bg = `${S3_IMAGES_BASE_URL}/transportation_bg.svg`;
const transportation_thumbnail = `${S3_IMAGES_BASE_URL}/transport_thumbnail.svg`;
const transport_card = `${S3_IMAGES_BASE_URL}/transport_card.svg`;
const mob_transport = `${S3_IMAGES_BASE_URL}/mob_transport.svg`;
const tech_bg = `${S3_IMAGES_BASE_URL}/tech_bg.png`;
const tech_thumbnail = `${S3_IMAGES_BASE_URL}/tech-thumbnail.png`;
const web_tech = `${S3_IMAGES_BASE_URL}/tech-card.png`;
const mob_tech = `${S3_IMAGES_BASE_URL}/mob_tech.png`;
const emp_bg = `${S3_IMAGES_BASE_URL}/emp_bg.png`;
const emp_thumbnail = `${S3_IMAGES_BASE_URL}/emp_thumbnail.png`;
const emp_card = `${S3_IMAGES_BASE_URL}/emp_card.png`;
const mob_emp = `${S3_IMAGES_BASE_URL}/mob_emp.png`;
const kitchen_bg = `${S3_IMAGES_BASE_URL}/kitchen_bg.png`;
const kitchen_thumbnail = `${S3_IMAGES_BASE_URL}/kitchen_thumbnail.png`;
const kitchen_card = `${S3_IMAGES_BASE_URL}/kitchen_card.png`;
const mob_kitchen = `${S3_IMAGES_BASE_URL}/mob_kitchen.png`;
const mob_ngo = `${S3_IMAGES_BASE_URL}/mob_ngo.png`;
const ngo_bg = `${S3_IMAGES_BASE_URL}/ngo_bg.png`;
const ngo_thumbnail = `${S3_IMAGES_BASE_URL}/ngo_thumbnail.png`;
const ngo_card = `${S3_IMAGES_BASE_URL}/ngo_card.png`;
const nishant_cxo_blog = `${S3_IMAGES_BASE_URL}/cxo_blog.png`;
const blog_cloud_cost = `${S3_IMAGES_BASE_URL}/blog_cloud_cost.jpg`;
const location_pin = `${S3_IMAGES_BASE_URL}/location.png`;
const aiml = `${S3_IMAGES_BASE_URL}/aiml-bg.jpeg`;
const aiml_web = `${S3_IMAGES_BASE_URL}/aiml-web.jpg`;
const ai_powered = `${S3_IMAGES_BASE_URL}/ai-powered.svg`;
const predictive = `${S3_IMAGES_BASE_URL}/predictive-analytics.svg`;
const nlp = `${S3_IMAGES_BASE_URL}/nlp.svg`;
const machine_learning = `${S3_IMAGES_BASE_URL}/ml.svg`;
const ai_cloud = `${S3_IMAGES_BASE_URL}/ai-cloud.svg`;
const global_delivery = `${S3_IMAGES_BASE_URL}/global-delivery.png`;
const fast_time = `${S3_IMAGES_BASE_URL}/fast-time.png`;
const compliance_ready = `${S3_IMAGES_BASE_URL}/compliance-ready.png`;
const custom_solutions = `${S3_IMAGES_BASE_URL}/custom-solutions.png`;
const landing4 = `${S3_IMAGES_BASE_URL}/landing4.jpg`;
const landing4_mob = `${S3_IMAGES_BASE_URL}/landing4-mob.jpg`;
const smart_op_thumbnail = `${S3_IMAGES_BASE_URL}/smart-op-thumbnail.jpg`;
const smart_op_web = `${S3_IMAGES_BASE_URL}/smart-op-web.jpg`;
const smart_op_mob = `${S3_IMAGES_BASE_URL}/smart-op-mob.png`;
const workflow_bg = `${S3_IMAGES_BASE_URL}/workflow-bg.jpg`;
const workflow_mob_bg = `${S3_IMAGES_BASE_URL}/workflow-bg-mob.png`;
const workflow_bg_web = `${S3_IMAGES_BASE_URL}/workflow-bg-web.jpg`;
const smart_op_tag = `${S3_IMAGES_BASE_URL}/smart-op-tag.png`;
const smart_operation_carousel = `${S3_IMAGES_BASE_URL}/smart-operation-carousel.png`;
const workflow_carousel = `${S3_IMAGES_BASE_URL}/workflow-carousel.jpg`;
const iot_Architecture = `${S3_IMAGES_BASE_URL}/iotArchitecture.svg`;
const iot_side = `${S3_IMAGES_BASE_URL}/iot-side.png`;
const iot_banner = `${S3_IMAGES_BASE_URL}/iot-Banner.jpg`;
const network_management_banner = `${S3_IMAGES_BASE_URL}/network-management.jpg`;
const radius_based_banner = `${S3_IMAGES_BASE_URL}/radius-based.jpg`;
const smart_security_banner = `${S3_IMAGES_BASE_URL}/smart-security.jpg`;
const security_surveillance_banner = `${S3_IMAGES_BASE_URL}/security-surveillance.jpg`;
const smart_lighting = `${S3_IMAGES_BASE_URL}/smart-lighting.svg`;
const predictive_maintenance = `${S3_IMAGES_BASE_URL}/predictive-maintenance.svg`;
const one_cloud = `${S3_IMAGES_BASE_URL}/one-cloud.svg`;
const home_building = `${S3_IMAGES_BASE_URL}/home-building.svg`;
const energy_automation = `${S3_IMAGES_BASE_URL}/energy-automation.svg`;
const security_surveillance = `${S3_IMAGES_BASE_URL}/security-surveillance.svg`;
const smart_security = `${S3_IMAGES_BASE_URL}/smart-security.svg`;
const radius_based = `${S3_IMAGES_BASE_URL}/radius-based.svg`;
const network_management = `${S3_IMAGES_BASE_URL}/network-management.svg`;
const VideoPlaceholder = `${S3_IMAGES_BASE_URL}/VideoPlaceholder.png`;
const browser_icon = `${S3_IMAGES_BASE_URL}/browser-icon.png`;


export const SHOW_BORDER_SCREEN = 'home';
export const SIDEBAR_ITEMS = {
  WHO_WE_ARE: 'Who We Are',
  SERVICES: 'Services',
  COMPANY: 'Company',
  SOLUTIONS: 'Solutions',
  MARKETPLACE: 'Marketplace',
  CONTACT: 'Contact',
  CONTACT_US: 'Contact Us',
  ABOUT_US: 'About Us',
  LEADERSHIP: 'Leadership',
  TEAM: 'Team',
  SOFTWARE_ENGINEERING: 'Software Engineering',
  CLOUD_DEVOPS: 'Cloud & DevOps',
  QUALITY_ASSURANCE: 'Quality Assurance',
  DESIGNING: 'Designing (UI/UX)',
  OPERATIONS: 'Operations',
  AIML: 'AI-Driven Solutions',
  IOT_AUTOMATION: 'IoT Automation',
  BLOGS: 'Blogs',
  SUCCESS_STORIES: 'Success Stories',
  LIFE_AT_WMP: 'Life At Wingman',
  TRAKWA: 'Trakwa',
  QUFREE: 'QuFree',
  CXOTULZ: 'CXOTulz',
  AWARDS: 'Awards',
  CAREERS: 'Careers'
};
export const IMAGES = {
  BLOG_CLOUD_COST: blog_cloud_cost,
  NISHANT_CXO_BLOG : nishant_cxo_blog,
  NGO_BG: ngo_bg,
  NGO_THUMBNAIL: ngo_thumbnail,
  NGO_CARD: ngo_card,
  MOB_NGO: mob_ngo,
  EMP_BG: emp_bg,
  EMP_THUMBNAIL: emp_thumbnail,
  EMP_CARD: emp_card,
  MOB_EMP: mob_emp,
  KITCHEN_BG :kitchen_bg,
  KITCHEN_THUMBNAIL: kitchen_thumbnail,
  MOB_KITCHEN: mob_kitchen,
  KITCHEN_CARD: kitchen_card,
  TECH_BG: tech_bg,
  TECH_THUMBNAIL: tech_thumbnail,
  TECH_WEB: web_tech,
  MOB_TECH: mob_tech,
  TRANSPORT_BG: transportation_bg,
  TRANSPORT_THUMBNAIL: transportation_thumbnail,
  TRANSPORT_WEB: transport_card,
  MOB_TRANSPORT: mob_transport,
  HEALTHCARE_THUMBNAIL: healthcare_thumbnail,
  HEALTHCARE_CAROUSEL: healthcare_carousel,
  HEALTHCARE_WEB: healthcare1,
  MOB_HEALTHCARE: mob_healthcare,
  HOSPITALITY_CARAOUSEL: hospitality_caraousel,
  MOB_HOSPITALITY: mob_hospitality,
  HOSPITALITY_STORY: hospitality_story,
  HOSPITALITY_THUMBNAIL: hospitality_thumbnail,
  ANKITA_QA_BLOG_IMG: ankita_blog_gpt,
  MOB_CXO: mob_dashboard,
  OWNERSHIP: ownership,
  TRUSTED_PARTNERSHIP: trusted_partners,
  REQUIREMENT_SCRUTINY: requirement_scrutiny,
  FLEXIBLE_PAYMENT: flexible_Payment,
  DEDICATED_RESOURCES: dedicated_resource,
  CENTARLIZED_SUPPORT: centralized_support,
  CXOTULZ: CXOTulz,
  DASHBOARD_CXO : Dashboard_cxo,
  ANUBHAV_BLOG_IMG_1 : anubhav_blog_img_1,
  ANUBHAV_BLOG_IMG_2 : anubhav_blog_img_2,
  ANKITA_BLOG_IMG : ankita_blog_img,
  CELEBRATION_10: celebration_10,
  CELEBRATION_11: celebration_11,
  CELEBRATION_12: celebration_12,
  CELEBRATION_13: celebration_13,
  CELEBRATION_14: celebration_14,
  CELEBRATION_15: celebration_15,
  CELEBRATION_16: celebration_16,
  CELEBRATION_17: celebration_17,
  CELEBRATION_18: celebration_18,
  CELEBRATION_19: celebration_19,
  CELEBRATION_20: celebration_20,
  CELEBRATION_21: celebration_21,
  CELEBRATION_22: celebration_22,
  CELEBRATION_23: celebration_23,


  MALE_DUMMY: male,
  FEMALE_DUMMY: female_dummy,
  ERIC: eric,
  REX: rex,
  KAPIL: kapil,
  SERGE: serge,
  ASHAV_IMG: leadership_ashav,
  OS_ASHAV_IMG: os_ashav_img,
  WELCOME_KIT: os_welcomekit,
  NEW_WELCOME_KIT: os_welcomekit_2,
  TEAM_IMG: os_team_img,
  TEAM_IMG1: os_team_img2,
  MISSION_IMG: mission_img,
  ROBO_IMG: robo_img,
  CORE_VALUE_DIAGRAM: core_value_diagram,
  INTEGRITY_VALUE: integrity_value,
  DILIGENCE_VALUE: diligence_value,
  OWNERSHIP_VALUE: ownership_value,
  DISCIPLINE_VALUE: discipline_value,
  COMMITMENT_VALUE: commitment_value,
  OPEN_COMMUNICATION_VALUE: open_communication_value,
  GROUP_IMG: card_group,
  GLOBE_IMG: globe,
  NO_COMPORMISE: no_compromise,
  TALENT_GROUP: pool_group,
  TECH_COMPETENCE: tech_competence,
  COST_OPTIMIZATION: cost_optimization,
  AWARDS_IMG: awards_img1,
  CERTIFICATE: awards_img,
  DOT_CIRCLES: circle_dot,
  RED_RECT: red_rect,
  BLUE_RECT: blue_rect,
  PREV: prev,
  NEXT: next,
  CARD_BG: card,
  TEAM_BG: team_bg,
  LEADERSHIP_BG: leadeship_bg,
  LINKDIN_ICON: linkdin_icon,
  MAIL_ICON: mail_icon,
  NISHANT_IMG: leadership_nishant,
  ALOK_IMG: leadership_alok,
  SQUARE_RED: square_red,
  RECT_BLUE: rect_blue,
  KUB_IMAGE_MV_1: kub_img_mv_1,
  KUB_IMAGE_MV_2: kub_img_mv_2,
  KUB_IMAGE_MV_3: kub_img_mv_3,
  KUB_IMAGE_MV_4: kub_img_mv_4,
  BLOG_CARD_IMG_1: blog_card_img_1,
  BLOG_CARD_IMG_2: blog_card_img_2,
  BLOG_CARD_IMG_3: blog_card_img_3,
  VIKASH_BLOG_IMG: vikas_blog_img,
  JAYANT_BLOG_IMG: jayant_blog_img,
  SAMYAKT_BLOG_IMG: samyakt_blog_img,
  MOHIT_BLOG_IMG: mohit_blog_img,
  UNIQUE_BLOG_IMG: unique_blog_img,
  HARPREET_BLOG_IMG: harpreet_blog_img,
  KAWALDEEP_BLOG_IMG: kawaldeep_blog_img,
  KEKASHRI_BLOG_IMG: kekashri_blog_img,
  MUKUL_BLOG_ING: mukul_blog_img,
  BLOG_CARD_IMG_5: blog_card_img_5,
  BLOG_CARD_IMG_6: blog_card_img_6,
  NETWORK_BG: network_management_bg,
  TECHNOLOGY_BG: technology_bg,
  NETWORK_WEB: network_mgt_web,
  TECHNOLOGY_WEB: technology_web,
  NETWORK_MOB: network_mgt_mob,
  TECHNOLOGY_MOB: technology_mob,
  CULTURE_PEOPLE: culture_people_img,
  CULTURE_PEOPLE_2: culture_people_img_2,
  CULTURE_INNOVATION: culture_innovation_img,
  CULTURE_BUILDING: culture_building_img,
  CULTURE_FAMILY: culture_family_img,
  CULTURE_PEOPLE_MOB: culture_people_mob,
  CULTURE_INNOVATION_MOB: culture_innovation_mob,
  CULTURE_BUILDING_MOB: culture_building_mob,
  CULTURE_FAMILY_MOB: culture_family_mob,
  CONTACT_IMG: contact_img,
  LOCATION_ICON: location,
  PHONE_ICON: phone_icon,
  USER_ICON: user_icon,
  MAIL_CONTACT_ICON: mail_contact_icon,
  PHONE_CONTACT_ICON: phone_contact_icon,
  MODAL_CROSS: modal_cross,
  CONTACT_MOB_IMG: contact_mob_img,
  ABOUT_MOB_ASHAV: about_ashav_mob,
  CORE_ROBO_IMG: core_robo_img,
  CORE_FIREWORK_IMG: core_firework_img,
  NAV_FOOTER_LINKDIN: Linkdein,
  NAV_FOOTER_INSTAGRAM: Instagram,
  NAV_FOOTER_FACEBOOK: facebook,
  WHO_WE_ARE_TEAM_IMG : team_img,
  CELEBRATION_1: celebration_1,
  CELEBRATION_2: celebration_2,
  CELEBRATION_3: celebration_3,
  CELEBRATION_4: celebration_4,
  CELEBRATION_5: celebration_5,
  CELEBRATION_6: celebration_6,
  CELEBRATION_7: celebration_7,
  CELEBRATION_8: celebration_8,
  CELEBRATION_9: celebration_9,
  CELEBRATION_25: celebration_25,
  CELEBRATION_26: celebration_26,
  CELEBRATION_27: celebration_27,
  CELEBRATION_28: celebration_28,
  CELEBRATION_29: celebration_29,
  CELEBRATION_30: celebration_30,
  CELEBRATION_31: celebration_31,
  CELEBRATION_32: celebration_32,
  CELEBRATION_33: celebration_33,
  CELEBRATION_34: celebration_34,
  CELEBRATION_35: celebration_35,
  CELEBRATION_36: celebration_36,
  CELEBRATION_37: celebration_37,
  CELEBRATION_38: celebration_38,
  CELEBRATION_39: celebration_39,
  CELEBRATION_40: celebration_40,
  CELEBRATION_41: celebration_41,
  CELEBRATION_42: celebration_42,
  CELEBRATION_43: celebration_43,
  CELEBRATION_44: celebration_44,
  RHYTHM_1: Rhythm_1,
  RHYTHM_2: Rhythm_2,
  RHYTHM_3: Rhythm_3,
  RHYTHM_4: Rhythm_4,
  RHYTHM_5: Rhythm_5,
  RHYTHM_6: Rhythm_6,
  RHYTHM_7: Rhythm_7,
  RHYTHM_8: Rhythm_8,
  RHYTHM_9: Rhythm_9,
  RHYTHM_10: Rhythm_10,
  RHYTHM_11: Rhythm_11,
  RHYTHM_12: Rhythm_12,
  RHYTHM_13: Rhythm_13,
  RHYTHM_14: Rhythm_14,
  RHYTHM_15: Rhythm_15,
  RHYTHM_16: Rhythm_16,
  RHYTHM_17: Rhythm_17,
  RHYTHM_18: Rhythm_18,
  RHYTHM_19: Rhythm_19,
  RHYTHM_20: Rhythm_20,
  RHYTHM_21: Rhythm_21,
  RHYTHM_22: Rhythm_22,
  RHYTHM_23: Rhythm_23,
  RHYTHM_24: Rhythm_24,
  RHYTHM_25: Rhythm_25,
  AIML_BG: aiml,
  AIML_WEB: aiml_web,
  AI_POWERED: ai_powered,
  PREDICTIVE_ANALYTICS: predictive,
  NLP: nlp,
  MACHINE_LEARNING: machine_learning,
  AI_CLOUD: ai_cloud,
  GLOBAL_DELIVERY: global_delivery,
  FAST_TIME: fast_time,
  COMPLIANCE_READY: compliance_ready,
  CUSTOM_SOLUTIONS: custom_solutions,
  WORKFLOW_MOB_BG: workflow_mob_bg,
  WORKFLOW_BG: workflow_bg,
  WORKFLOW_BG_WEB: workflow_bg_web,
  SMART_OP_THUMBNAIL: smart_op_thumbnail,
  SMART_OPEARTION_WEB: smart_op_web,
  SMART_OPERATION_MOB: smart_op_mob,
  IOT_ARCHITECTURE: iot_Architecture,
  IOT_SIDE: iot_side,
  IOT_BANNER: iot_banner,
  NETWORK_MANAGEMENT_BANNER: network_management_banner,
  RADIUS_BASED_BANNER: radius_based_banner,
  SMART_SECURITY_BANNER: smart_security_banner,
  SECURITY_SURVEILLANCE_BANNER: security_surveillance_banner,
  SMART_LIGHTING: smart_lighting,
  PREDICTIVE_MAINTENANCE: predictive_maintenance,
  ONE_CLOUD: one_cloud,
  HOME_BUILDING: home_building,
  ENERGY_AUTOMATION: energy_automation,
  SECURITY_SURVEILLANCE: security_surveillance,
  SMART_SECURITY: smart_security,
  RADIUS_BASED: radius_based,
  NETWORK_MANAGEMENT: network_management,
  BROWSER_ICON: browser_icon,
  KNOX_HERO1: knox_hero1,
  KNOX_HERO2: knox_hero2,
  KNOX_LOGO: knox_logo,
  SATM_HERO1: satm_hero1,
  SATM_HERO2: satm_hero2,
  SATM_LOGO: satm_logo,
  STRESSOPS_HERO1: stressops_hero1,
  STRESSOPS_HERO2: stressops_hero2,
  STRESSOPS_LOGO: stressops_logo,
  DUWISE_HERO1: duwise_hero1,
  DUWISE_HERO2: duwise_hero2,
  DUWISE_LOGO: duwise_logo,
  ORCAFLO_HERO1: orcaflo_hero1,
  ORCAFLO_HERO2: orcaflo_hero2,
  ORCAFLO_LOGO: orcaflo_logo,
};

// images
export const images = {
  location_pin: location_pin,
  MOB_CXO: mob_cxo,
  MOB_TRAKWA: mob_trakwa,
  MOB_QUFREE: mob_qufree,
  EXPLORE_1: explore_1,
  EXPLORE_2: explore_2,
  EXPLORE_3: explore_3,
  CXO_THUMBNAIL: cxo_thumbnail,
  PROFILE_QU: profile_qufree,
  ACC_CREATED: account_created,
  CSTM_DASH: cstm_dashboard,
  TAGLINE: tagline,
  QU1: qu1,
  QU2: qu2,
  QU3: qu3,
  QU4: qu4,
  QU_REGISTER:qu_register,
  QU_SIGNUP: qu_signup,
  QU_PHONE: qu_phone,
  QUFREE_SCREEN: qufree_screen,
  QUFREE_THUMBNAIL: qufree_thumbnail,
  TRAKWA1: trakwa1,
  TRAKWA2: trakwa2,
  TRAKWA3: trakwa3,
  TRAKWA_THUMBNAIL:trakwa_thumbnail,
  TRAKWA_APP: trakwa_app,
  TRAKWA_SIMPLIFIED: trakwa_simplified,
  cxotulzLogo: cxotulz_logo,
  Qufree: qufree,
  Trakwa: trakwa,
  CxoReport: cxo_report,
  loginvector: login_vector,
  Vector: vector,
  costAnalysis: cost_analysis,
  cloudSwitch: cloud_switch,
  solutionBullet: solution_bullet,
  cardImg: card_img,
  blue_box: blueBox,
  circles: Circles,
  net_img: netImg,
  Prev: prev,
  Next: next,
  blue_bg: blueBg,
  sde: SDE,
  operations: Operations,
  UI: ui,
  Cloud: cloud,
  QA: qa,
  AIML: aimlGif,
  Consulting: consulting,
  Hospitality: hospitality,
  Group: group,
  Technology: technology,
  Transportaion: transportaion,
  dark_blue_box: darkBlueBox,
  red_box: redBox,
  circles_vert: circlesVert,
  red_vert_line: redVertLine,
  SE_bg: SeBg,
  SE_Img: SeImg,
  mob_app_dev: mobAppDev,
  web_app_dev: webAppDev,
  soft_engg: softwareEngg,
  product_engg: productEngg,
  poc: POC,
  quote: Quotes,
  logo: wmpLogo,
  bullet: BULLET,
  SERVICES_FOOTER_BG: services_footer_img,
  DEVOPS_BG: devops_bg,
  DEVOPS_IMG: devops_img,
  QA_IMG: qa_img,
  DESIGNING_IMG: designing_img,
  OPERATIONS_IMG: operations_img,
  SCROLL_DOWN: scroll_down,
  RIGHT_ARROW: right_arrow,
  VIDEO_PLACEHOLDER: VideoPlaceholder,
  KNOX_HERO1: knox_hero1,
  KNOX_HERO2: knox_hero2,
  KNOX_LOGO: knox_logo,
  SATM_HERO1: satm_hero1,
  SATM_HERO2: satm_hero2,
  SATM_LOGO: satm_logo,
  STRESSOPS_HERO1: stressops_hero1,
  STRESSOPS_HERO2: stressops_hero2,
  STRESSOPS_LOGO: stressops_logo,
  DUWISE_HERO1: duwise_hero1,
  DUWISE_HERO2: duwise_hero2,
  DUWISE_LOGO: duwise_logo,
  ORCAFLO_HERO1: orcaflo_hero1,
  ORCAFLO_HERO2: orcaflo_hero2,
  ORCAFLO_LOGO: orcaflo_logo,
}

export const FIVE_THOUSAND_CONST = 5000;
export const SEVEN_THOUSAND_CONST = 7000;
export const TWO_THOUSAND_CONST = 2000;
export const ONE_THOUSAND = 1000;
export const EIGHT_HUNDRED = 800;

// Home page video buttons configuration
export const videoButtons = [
  { start: 0, end: 11, text: 'Explore IoT Services', route: '/iot-automation' },
  { start: 12, end: 23, text: 'Watch How It Works', route: '/aiml-services' },
  { start: 24, end: 34, text: 'Discover Cloud Solution', route: '/devOps' },
  { start: 35, end: 46, text: 'Explore Our Solutions', route: '/qa' },
  { start: 47, end: 999, text: 'See How We Work', route: '/designing' }
];

// Home page text constants
export const HOME_TEXT = {
  LOADING: 'Loading...',
  LOADING_DESC: 'Please wait while we load your content',
  LOADING_VIDEO: 'Loading video...',
  SCROLL_DOWN: 'Scroll Down',
  VIDEO_NOT_SUPPORTED: 'Your browser does not support the video tag.'
};

// Video URLs
export const VIDEO_URLS = {
  HOME_VIDEO: 'https://www.wingmanpartners.com/videos/landing-page-video-v1.0.0.webm'
};

// Admin video management constants


//home page consts
export const carouselImages = [landing4, landing1, landing2, landing3];
export const caraouselImagesMob = [landing4_mob, landing1_mob, landing2_mob, landing3_mob];
// home page const ends


//case Study const
export const carouselImagesCaseStudy = [workflow_carousel, smart_operation_carousel, netImg, technology_carouel, hospitality_caraousel, healthcare_carousel, transportation_thumbnail, tech_thumbnail, emp_thumbnail, kitchen_thumbnail, ngo_thumbnail];
// cast study consts ends


// Services const
export const gifs = [
  { path: aimlGif, val: "AI-Driven Solutions", routeLink: pageRoutes.AIML },
  { path: cloud, val: "Cloud & DevOps", routeLink: pageRoutes.DevOps },
  { path: SDE, val: "Software Engineering", routeLink: pageRoutes.SoftwareEngineering,},
  { path: qa, val: "Quality Assurance", routeLink: pageRoutes.QA },
  { path: ui, val: "Designing (UI/UX)", routeLink: pageRoutes.Designing },
  { path: Operations, val: "Operations", routeLink: pageRoutes.Operations },
  { path: iotGif, val: "IoT Automation", routeLink: pageRoutes.IOTAutomation },
];
// services consts ends


// testimonials consts
export const headerImages = [consulting, group, technology, hospitality, transportaion, healthcare, realEstate, engage, organization, Food];
export const partnerImages = [IMAGES.ERIC, IMAGES.SERGE, IMAGES.REX, IMAGES.KAPIL];
// testimonials consts end


//Blogs consts starts
export const dataBlogs = [
  {
    by: "Kawaldeep Singh",
    date: "13 February 2026",
    URL: "https://medium.com/@besocial_27455/why-most-microservices-fail-in-production-78bf73a73812",
    UrlDesc:
      "Why Most Microservices Fail in Production",
    image: "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/microservices-fail-in-production.png"
  },
  {
    by: "Hrithik Hiranwar",
    date: "09 January 2026",
    URL: "https://medium.com/@besocial_27455/chaos-engineering-bdc3581caf24",
    UrlDesc:
      "Chaos Engineering",
    image: "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/chaos-engineering.png"
  }
];
//blogs const ends

//Software Engg consts
export const cardData = [
  { URL: webAppDev, desc: 'Web App Development', routeLink: pageRoutes.WebAppDev },
  { URL: mobAppDev, desc: 'Mobile App Development', routeLink: pageRoutes.MobileAppDev },
  { URL: productEngg, desc: 'Product Reengineering', routeLink: pageRoutes.ProductReEngg },
  { URL: softwareEngg, desc: 'Software Integration', routeLink: pageRoutes.SoftwareIntegration },
  { URL: POC, desc: 'Proof Of Concepts', routeLink: pageRoutes.POC }
];


export const technologyImages = [
  { name: 'Java', url: Java },
  { name: 'Python', url: Python },
  { name: 'Node', url: Node },
  { name: 'React Native', url: ReactNative },
  { name: 'HTML 5', url: HTML5 },
  { name: 'CSS 3', url: CSS3 },
  { name: 'Vue', url: Vue },
  { name: 'Angular', url: Angular }
];

export const techstack = [
  { name: 'Node', url: Node },
  { name: 'React Native', url: ReactNative },
  { name: 'Docker', url: docker },
  { name: 'Github Actions', url: github },
  { name: 'Amazon Web Services', url: aws },
  { name: 'PostgreSQL', url: psql },
  { name: 'Angular', url: Angular },
  {name: 'FireStore', url: firebase}
];

export const cxoTechStack = [
  { name: 'Node', url: Node },
  { name: 'React Native', url: ReactNative },
  { name: 'Docker', url: docker },
  { name: 'Github Actions', url: github },
  { name: 'Amazon Web Services', url: aws },
  { name: 'PostgreSQL', url: psql }
];

export const qufreeTechStack = [
  { name: 'Node', url: Node },
  { name: 'React Native', url: ReactNative },
  { name: 'Docker', url: docker },
  { name: 'Github Actions', url: github },
  { name: 'Amazon Web Services', url: aws },
  { name: 'PostgreSQL', url: psql },
  { name: 'sendGrid', url: sendgrid },
  { name: 'FireStore', url: firebase}
];
export const carouselTechOptions = {
  loop: true,
  autoplay: true,
  autoplayTimeout: ONE_THOUSAND, // Set the autoplay timeout in milliseconds
  animteOut: true,
  animateIn: true,
  dots: false,
  autoplaySpeed: EIGHT_HUNDRED,    // Set the speed of the automatic transition (in milliseconds)
};
// Software Engg consts ends

// DevOps consts
export const cardDataDevOps = [
  { URL: cloud_infra, desc: 'Cloud Infrastructure Consulting', routeLink: pageRoutes.CloudInfra },
  { URL: cloud_migration, desc: 'Cloud Migration', routeLink: pageRoutes.CloudMigration },
  { URL: devops_auto, desc: 'DevOps Automation', routeLink: pageRoutes.DevOpsAuto },
  { URL: devops_operations, desc: 'DevOps Operations', routeLink: pageRoutes.DevopsOperations },
  { URL: security, desc: 'Security & Cost Optimization', routeLink: pageRoutes.Security },
]

// AI-ML consts
export const cardDataAiml = [
  { URL: ai_powered, desc: "AI-Powered Automation", routeLink: pageRoutes.AIPoweredAutomation },
  { URL: predictive, desc: "Predictive Analytics & Forecasting", routeLink: pageRoutes.PredictiveAnalytics },
  { URL: nlp, desc: "Natural Language Processing (NLP)", routeLink: pageRoutes.NLP },
  { URL: machine_learning, desc: "Machine Learning & Deep Learning", routeLink: pageRoutes.MachineLearning },
  { URL: ai_cloud, desc: "AI on the Cloud", routeLink: pageRoutes.AiOnCloud },
];

export const teamDevopsImages = [devops_badge1, devops_badge2, devops_badge3, devops_badge4, devops_badge5];

export const devopsExpertiseImages = [
  { name: 'GCP', url: google_cloud },
  { name: 'AWS', url: aws },
  { name: 'Azure', url: azure },
];
//DevOps const ends

//Operations consts
export const cardDataOperations = [
  { URL: tech_writing, desc: 'Technical Writing', routeLink: pageRoutes.TechManagement },
  { URL: project_management, desc: 'Project Management ', routeLink: pageRoutes.ProjectManagement },
  { URL: product_management, desc: 'Product Strategy & Management', routeLink: pageRoutes.ProductManagement },
  { URL: monitoring, desc: 'Level 3 Support (L3: 24x7)', routeLink: pageRoutes.Support },
]

export const teamOperationsImages = [PMI];

//Operations consts ends

//QA const 
export const cardDataQA = [
  { URL: testing_and_auto, desc: 'Testing & Automation', routeLink: pageRoutes.TestingAndAutomation },
  { URL: API_driven_testing, desc: 'API Driven Testing', routeLink: pageRoutes.ApiDrivenTesting },
  { URL: performance_testing, desc: 'Performance Testing', routeLink: pageRoutes.PerformanceTesting },
  { URL: penetration_testing, desc: 'Penetration Testing', routeLink: pageRoutes.PenetrationTesting },
]

export const teamQAImages = [sumo_qa, istqb_qa];
//QA const ends

//Success Stories const 
export const cardDataSuccessStories = [
  {URL: workflow_bg, heading: 'Workflow Automation with Intelligence', desc: "We deliver AI and ML-powered solutions that automate repetitive workflows, extract insights........", routeLink: pageRoutes.WorkflowAutomation, selector: 'workflow_automation_with_intelligence' }, 
  {URL: smart_op_tag, heading: 'Smart Operations & Forecasting', desc: "We help businesses transform raw, unstructured data into actionable insights using AI-driven systems........", routeLink: pageRoutes.SmartOperations, selector: 'smart_operations_forecasting'},
  {URL: netImg, heading: 'Network Management', desc: 'Our client, a cutting-edge Network Management Solution, required a reliable and efficient partner to ensure the seamless functioning of its services..... ', routeLink: pageRoutes.NetworkManagement, selector: 'network_management'},
  {URL: technology_carouel, heading: 'IoT Security Solutions', desc: "A global technology company that provides the world's most valuable brands with innovative merchandising,security, and IoT solutions.....", routeLink: pageRoutes.Technology, selector: 'iot_security_solutions'},
  {URL: hospitality_caraousel, heading: 'Hospitality', desc: "A Hotels Corporation is an American multinational hospitality giant that manages and franchises luxury........", routeLink: pageRoutes.Hospitality, selector: 'hospitality'},
  {URL: healthcare_carousel, heading: 'Healthcare', desc: "A rigorous, scientifically validated platform that collects continuous streams of data with precision and accuracy........", routeLink: pageRoutes.Healthcare, selector: 'healthcare'},
  {URL: transportation_thumbnail, heading: 'Transportation', desc: "An upcoming startup that is revolutionizing the rideshare community by offering an economical option to connect riders and ........", routeLink: pageRoutes.Transportation, selector: 'transportation'},
  {URL: tech_thumbnail, heading: 'Tech-Enabled Spaces', desc: "The company emerged as a trailblazer in the Indian commercial space sector, offering a tech-enabled network of flexible ........", routeLink: pageRoutes.TechSpaces, selector: 'tech_enabled_spaces'},
  {URL: emp_thumbnail, heading: 'Employment and Community Engagement', desc: "Our partner is a dynamic social platform designed to accelerate work-life happiness. With a focus on connecting job seekers ........", routeLink: pageRoutes.EmpCommunity, selector: 'employment_community_engagement'},
  {URL: kitchen_thumbnail, heading: 'Kitchen and Dining', desc: "Our partner, the largest F&B marketplace in the South Asia Region, serves as a pivotal platform showcasing a diverse array of dining products........", routeLink: pageRoutes.KitchenDining, selector: 'kitchen_dining_ngo'},
  {URL: ngo_thumbnail, heading: 'Non-Governmental Organization', desc: "The Foundation, a non-government organization (NGO), is dedicated to the preservation of nature and the improvement of living conditions for the less fortunate ........", routeLink: pageRoutes.NonGovOrg, selector: 'ngo'},
]
//Success Stories const ends

//Designing const 
export const cardDataDesigning = [
  { URL: web_designing, desc: 'Web Designing', routeLink: pageRoutes.WebDesigning },
  { URL: app_designing, desc: 'App Designing', routeLink: pageRoutes.AppDesigning },
  { URL: info_architecture_design, desc: 'Information Architecture Design', routeLink: pageRoutes.InfoArchitectureDesign },
]
//Designing const ends

//IoT Portfolio & Experience const 
export const cardDataIoTPortfolio = [
  { URL: radius_based, desc: 'Radius-Based Device Unlocking', routeLink: pageRoutes.RadiusDeviceUnlocking },
  { URL: smart_security, desc: 'Smart Security Monitoring System', routeLink: pageRoutes.SmartSecurityMonitoring },
  { URL: network_management, desc: 'Network Management System (NMS)', routeLink: pageRoutes.NetworkManagementSystem },
  { URL: security_surveillance, desc: 'Security & Surveillance', routeLink: pageRoutes.SecuritySurveillance }
];

//Footer consts
export const socialMediaImg = [
  { url: facebook, link: "https://www.facebook.com/wingmanpartners" },
  { url: Linkdein, link: "https://www.linkedin.com/company/wingmanpartners/?viewAsMember=true" },
  { url: mail, link: "mailto:connect@wingmanpartners.com" },
  { url: Instagram, link: "https://www.instagram.com/wingmanpartners/" },
];
//Footer consts end


//For Scroll to the top
export const scrollToTop = () => {
  setTimeout(() => {
      window.scrollTo(0, 0);
    }, 10);
};
